<ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: listMenu }"></ng-container>
<ng-template #menuTpl let-menus>
    <!-- User image -->
  <ng-container *ngFor="let menu of menus">
    <li
      *ngIf="!menu.menuItemData || menu.menuItemData.length === 0"
      nz-menu-item
      [nzPaddingLeft]="menu.level * 24"
    >
      <a [routerLink]="[menu.path]"><i nz-icon [nzType]="menu.icon" *ngIf="menu.icon"></i>
      <span>{{ !isCollapsed ? menu.caption:menu.shortCaption }}</span></a>
    </li>
    <li
      *ngIf="menu.menuItemData && menu.menuItemData.length > 0"
      nz-submenu
      [nzPaddingLeft]="menu.level * 24"
      [nzOpen]="menu.isShowListFirst"
      nzTitle="{{!isCollapsed ? menu.caption:menu.shortCaption}}"
      [nzIcon]="menu.icon"
    >
      <ul class="sub-menu">
        <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: menu.menuItemData}"></ng-container>
      </ul>
    </li>
  </ng-container>
</ng-template>
